/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { businessTypes } from "./signupConfig";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const BusinessTypePicker = defineComponent<Props>({
  name: "BusinessTypePicker",
  props: ["value", "onChange"],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <fieldset>
        <legend class="mb-2 text-sm font-medium text-base-content">
          {t("signup.business.title")}
        </legend>
        <div class="grid grid-cols-3 gap-2 sm:grid-cols-5 xl:grid-cols-9">
          {businessTypes.map((type) => {
            const selected = props.value === type.id;
            return (
              <button
                key={type.id}
                type="button"
                aria-pressed={selected}
                onClick={() => props.onChange(type.id)}
                class={[
                  "flex min-w-0 flex-col items-center gap-1 rounded-lg border px-1.5 py-2.5 text-center text-xs font-medium transition-all",
                  selected
                    ? "border-primary bg-primary/10 text-primary ring-1 ring-primary"
                    : "border-base-300 bg-base-100 text-base-content/80 hover:border-base-content/30 hover:bg-base-200",
                ]}
              >
                <span class="material-symbols-outlined text-xl">
                  {type.icon}
                </span>
                <span class="w-full truncate">
                  {t(`signup.business.${type.id}`)}
                </span>
              </button>
            );
          })}
        </div>
      </fieldset>
    );
  },
});
